<div class="zone-regions-result">
  <ng-template #countingCell let-row>
    <div class="flex-row gap-8 start-center">
      <ui-toggle
        (click)="$event.stopPropagation()"
        [disabled]="isProcessing(row._id)"
        [ngModel]="!!row.countingEnabled"
        (ngModelChange)="onToggleZoneCounting(row, $event)"
      ></ui-toggle>
      <span class="counting-label" [class.counting-label-on]="row.countingEnabled">
        {{ (row.countingEnabled ? 'ZONE_REGIONS.TABLE.COUNTING_ON' : 'ZONE_REGIONS.TABLE.COUNTING_OFF') | translate }}
      </span>
    </div>
  </ng-template>

  <ng-template #previewCell let-row>
    <div class="camera-snapshot">
      <ui-zone-region-preview [camera]="row"></ui-zone-region-preview>
    </div>
  </ng-template>

  @if (list(); as listResponse) {
    <div class="zone-regions-result__toolbar">
      <span class="zone-regions-result__count">{{ listResponse.count }} {{ 'DATABASE.ZONE_REGIONS' | translate }}</span>
      <div class="zone-regions-result__filters">
        <ui-search
          [placeholder]="'ZONE_REGIONS.PLACEHOLDERS.SEARCH_BY_NAME' | translate"
          [searchQuery]="searchQuery()"
          (onInput)="onSearchQuery($event)"
        ></ui-search>
        <ui-camera-select-button
          [selectedCount]="selectedCameraList().length"
          (click)="openSelectCameraModal()"
        ></ui-camera-select-button>
      </div>
    </div>

    @if (selectedCameraList().length) {
      <div class="zone-regions-result__chips">
        <div
          class="zone-regions-result__camera-chip"
          [matMenuTriggerFor]="camerasMenu"
        >
          <ui-filter-chip
            [title]="selectedCameraList().length + ' ' + ('WALL_LIST.CAMERA_FILTER' | translate)"
            [allowDelete]="false"
          ></ui-filter-chip>
        </div>
        <mat-menu #camerasMenu="matMenu" xPosition="after" yPosition="below">
          <div class="zone-regions-result__camera-menu">
            @for (camera of selectedCameraList(); track camera.cameraId) {
              <ui-filter-chip
                [title]="cameraLookup()[camera.cameraId]?.edgeOnly?.name ?? camera.name ?? camera.cameraId"
                [allowDelete]="true"
                (removeClicked)="removeCameraFilter(camera.cameraId)"
              ></ui-filter-chip>
            }
          </div>
        </mat-menu>
      </div>
    }

    @if (isFiltering()) {
      <div class="zone-regions-result__preloader">
        <ui-preloader [color]="preloaderColor.blue" [diameter]="40"></ui-preloader>
      </div>
    } @else if (listResponse.zoneRegions.length) {
      @if (listTableConfig(); as config) {
        <div class="zone-regions-result__table">
          <ui-dataset-table
            [data]="listResponse.zoneRegions"
            [config]="config"
            (rowAction)="onRegionRowAction($event)"
          ></ui-dataset-table>
        </div>
      }
    } @else {
      <ui-no-data [title]="'ZONE_REGIONS.NO_RESULTS.TITLE' | translate"></ui-no-data>
    }
  }

  @if (detail(); as detailResponse) {
    <div class="zone-region-detail__header">
      <div>
        <span>
          {{ 'ZONE_REGIONS.TABLE.ZONE_COUNTING' | translate }}:
          {{ (detailResponse.zoneRegion.countingEnabled ? 'ZONE_REGIONS.TABLE.COUNTING_ON' : 'ZONE_REGIONS.TABLE.COUNTING_OFF') | translate }}
        </span>
      </div>
      <button
        type="button"
        class="zone-region-detail__delete ui-icon-trash"
        [disabled]="deletingRegionId() === detailResponse.zoneRegion._id"
        [title]="'COMMON.DELETE' | translate"
        [attr.aria-label]="'COMMON.DELETE' | translate"
        (click)="deleteZoneRegion(detailResponse.zoneRegion)"
      ></button>
    </div>

    @if (detailResponse.cameras.length) {
      @if (cameraTableConfig(); as config) {
        <div class="zone-regions-result__table">
          <ui-dataset-table
            [data]="detailResponse.cameras"
            [config]="config"
            (rowAction)="onCameraRowAction($event)"
          ></ui-dataset-table>
        </div>
      }
    } @else {
      <ui-no-data [title]="'CAMERA_SELECT_TAB.NOT_FOUND' | translate"></ui-no-data>
    }
  }
</div>
